import React from 'react';
import MagicButton from 'components/MagicButton/MagicButton';
import { Points } from 'components/Points/Points';
import './GenericGroupContainer.css';

interface GenericGroupContainerProps {
  title: string;
  groupName: string;
  lowPrice: number;
  highPrice: number;
  onRemoveAll?: () => void;
  onReset?: () => void;
  isRemoved?: boolean;
  children?: React.ReactNode;
}

const GenericGroupContainer: React.FC<GenericGroupContainerProps> = ({
  title,
  groupName,
  lowPrice,
  highPrice,
  onRemoveAll,
  onReset,
  isRemoved = false,
  children,
}) => {
  return (
    <div className="generic-group-container">
      {/* Left Panel - Group Info */}
      <div className="generic-group-left">
        <div className="generic-info-section">
          <div className="generic-name-wrapper">
            <p className="generic-name">
              <strong>{groupName}</strong>
            </p>
          </div>
          <div className="generic-action">
            <MagicButton
              label={isRemoved ? "Reset" : "Remove All"}
              icon={
                isRemoved ? (
                  <img 
                    src="https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/ViewCard/reset.svg"
                    alt="Reset"
                    style={{ width: 16, height: 16 }}
                  />
                ) : (
                  <img 
                    src="https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/ViewCard/want-no.svg"
                    alt="Remove"
                    style={{ width: 16, height: 16 }}
                  />
                )
              }
              color="dark-grey"
              onPress={isRemoved ? (onReset || (() => {})) : (onRemoveAll || (() => {}))}
            />
          </div>
        </div>
      </div>

      {/* Right Panel - Cards */}
      <div className="generic-group-right">
        {/* Header */}
        <div className="generic-group-header">
          <div className="header-left">
            <span className="header-title">{title}</span>
          </div>
          <div className="header-right">
            <div className="price-range">
              <div className="price-item">
                <span className="price-label">Low</span>
                <Points points={lowPrice} type="small" />
              </div>
              <div className="price-item">
                <span className="price-label">High</span>
                <Points points={highPrice} type="small" />
              </div>
            </div>
          </div>
        </div>

        {/* Body - Card Grid */}
        <div className="generic-group-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default GenericGroupContainer;